import {isLearnerPersona} from "@khan/guide-core-helpers";
import {useGuideState} from "@khan/guide-state";
import {useUserAttributes} from "@khan/shared-core";
import {useLocation} from "@khan/urls";

/**
 * Custom hook to determine if the Add Reference button should be hidden.
 * Encapsulates the logic for checking learner personas and student emulation.
 */
export const useShouldHideAddReferenceButton = (): boolean => {
    const userAttributes = useUserAttributes();
    const {pathname} = useLocation();
    const isEmulatingLearner = useGuideState("userAsStudent");

    return isLearnerPersona({
        userAttributes,
        pathname,
        isEmulatingLearner,
    });
};
